import { ActivatedRoute } from '@angular/router';
import {
  Component,
  OnInit,
  Pipe,
  PipeTransform,
  AfterViewChecked,
  Renderer2,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { staticContent } from './help-content';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html'
})
export class HelpComponent implements OnInit, AfterViewChecked, AfterViewInit {
  helpItems = staticContent;
  activeId: string;
  search: string;
  fragment: string;

  constructor(private route: ActivatedRoute, private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
      //open up hidden div upon link click from homepage banner for caia information
      if(this.fragment === '_Toc202836376'){
        this.activeId = '_Toc202836376';
      } else if(this.fragment === '_Toc202836362'){
        //open up hidden div upon Report Card Lost or Stolen link click. 
        this.activeId = '_Toc202836362';
      }
    });
  }

  ngAfterViewInit(){
    const element = this.el.nativeElement.querySelector('.snowLink');
    if(element){
      this.renderer.setStyle(element, 'text-decoration', 'underline')
    }
  }

  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        document.querySelector('#' + this.fragment).scrollIntoView();
      }
    } catch (e) {}
  }

  toggleHelp(id: string) {
    if (this.activeId === id) {
      this.activeId = null;
    } else {
      this.activeId = id;
    }
  }
}

@Pipe({
  name: 'helpFilter'
})
export class HelpFilterPipe implements PipeTransform {
  transform(items: Array<any>, searchTerm: string): Array<any> {
    if (!items || !searchTerm) {
      return items;
    }
    searchTerm = searchTerm.toUpperCase();
    return items.filter(item => {
      return (
        item.TITLE.toUpperCase().includes(searchTerm) ||
        item.DETAIL.toUpperCase().includes(searchTerm)
      );
    });
  }
}
